export default __webpack_public_path__ + "static/media/opsDashboardIcon.d91f82f8.svg";